import moment from 'moment';
import QRCode from 'qrcodejs2';
import { payBatchPolicy } from '@/views/insure/request2';
export default {
  data() {
    return {
      minute: 0,
      second: 0,
      paid: 0,
      overTime: false,
      price: '',
      setInterval: null,
      payMethod: undefined,
      thirdPayLink: ''
    };
  },
  async created() {
    const res = await payBatchPolicy({
      customerId: this.$route.params.customerId,
      batchPolicyId: this.$route.params.batchPolicyId,
      position: this.$route.params.position
    });
    if (res.payType == 6) {
      this.paid = 1;
    } else {
      this.price = res.payAmount;
      this.payMethod = res.channel;
      if (res.thirdPayLink) {
        this.thirdPayLink = res.thirdPayLink;
        this.paid = 2;
        this.$nextTick(() => {
          new QRCode(this.$refs.qrcode, {
            text: this.thirdPayLink,
            // 需要转换为二维码的内容
            width: 200,
            height: 200,
            colorDark: '#000000',
            colorLight: '#ffffff'
          });
        });
      } else {
        return;
      }
      let lastTime = moment(res.deadline).format('YYYY-MM-DD').valueOf();
      let nowTime = moment().valueOf();
      if (lastTime > nowTime) {
        this.setInterval = setInterval(() => {
          this.setTime();
        }, 1000);
      } else {
        this.paid = 1;
        this.overTime = true;
      }
    }
  },
  beforeDestroy() {
    clearInterval(this.setInterval);
  },
  methods: {
    // 根据某一时刻倒计时
    setTime() {
      let lastTime = moment('2023-07-17 18:51:00').valueOf();
      let nowTime = moment().valueOf();
      if (lastTime > nowTime) {
        let times = (lastTime - nowTime) / 1000;
        this.minute = Math.floor(times % 86400 % 3600 / 60);
        this.second = Math.floor(times % 86400 % 3600 % 60);
        if (this.minute == 0 && this.second == 0) {
          clearInterval(this.setInterval);
          this.paid = 1;
          this.overTime = true;
          this.minute = 0;
          this.second = 0;
        }
      } else {
        clearInterval(this.setInterval);
        this.paid = 1;
        this.overTime = true;
        this.minute = 30;
        this.second = 0;
      }
    }
  }
};